export default __webpack_public_path__ + "static/media/ClassPass.a9923171.svg";